import { Component, OnInit } from '@angular/core';

import { PrismDataSource } from '../../models/prism-data-source.model';
import { SettingsDepositOption } from '../../models/settings-deposit-option.model';
import { SettingsDepositModel } from '../../models/settings-deposit.model';
import { User } from '../../models/user.model';
import { AuthorizationService } from '../../services/authorization.service';
import { DepositSettingsService } from '../../services/depositSettings-api.service';
import { GlobalFilterService } from '../../services/global-filter.service';
import { ReconApiService } from '../../services/recon-api.service';

const DepositOptions: SettingsDepositOption[] = [
    { ID: 0, Name: 'None', Description: 'Please make a Deposit Type selection.' },
    { ID: 1, Name: 'Lockbox', Description: 'Client deposits loaded directly from bank feed' },
    {
        ID: 2, Name: 'Deposit Assumption',
        Description: 'Client chooses to have deposits created based on received remittance details - this option assumes the PBM has made a payment for the remittance they are providing',
    },
    {
        ID: 3, Name: 'Deposit Confirmation',
        // tslint:disable-next-line:max-line-length
        Description: 'Client chooses to validate deposits prior to posting - a list of deposits will be generated based on received remittance details but the deposits will not post until the client confirms they have received funds from the PBM',
    },
    {
        ID: 4, Name: 'Defer to Store Group',
        Description: 'For PSAOs - client defers decision to a store group to assume deposits based on remittances received or to confirm deposits prior to posting',
    },
];

const depositAssumptionCodes = [
    'NO',   // No selection.
    'LB',   //  Lockbox
    'DA',   //  Deposit Assumption
    'DC',   //  Deposit Confirmation
    'DS',   //  Defer to Store Group
];

@Component({
    selector: 'app-settings-deposit',
    templateUrl: './deposit-settings.component.html',
    providers: [
        AuthorizationService,
        ReconApiService,
    ],
})

export class DepositSettingsComponent implements OnInit {
    private _currentUser: User;
    public validForm = true;

    private _selectionHasChanged = false;

    public get SelectionHasChanged(): boolean { return this._selectionHasChanged; }
    private _clientId: string;

    public get clientId(): string { return this._clientId; }
    private _selectedDepositOption: SettingsDepositOption = null;

    private _selectedClientModel: SettingsDepositModel = null;
    public get selectedDepositOption(): SettingsDepositOption { return this._selectedDepositOption; }

    private _depositOptionSelections: SettingsDepositOption[] = DepositOptions;

    public get DepositOptionSelections(): SettingsDepositOption[] { return this._depositOptionSelections; }

    public showDepositAssumptionMessage: boolean;
    public showDepositConfirmationMessage: boolean;

    constructor(private authorizationService: AuthorizationService,
                private globalFilterService: GlobalFilterService,
                private reconApi: ReconApiService,
                private depositSettingsService: DepositSettingsService) {

            this.showDepositAssumptionMessage = false;
            this.showDepositAssumptionMessage = false;
            globalFilterService.clientDataSourceSelectionChanged.subscribe((selection) => {
            this.onClientSelectionChanged(selection);
        })
            globalFilterService.clientEnvDataSourceSelectionChanged.subscribe((selection) => {

            this.onClientSelectionChanged(selection);
        })
            authorizationService.CurrentUser().subscribe((user) => { this._currentUser = user; });
            this._clientId = globalFilterService.selectedEnvironment.ClientId4Digit
            this.initializeDepositSettings()
    }

    public checkShowMessage(selectedCode: string): boolean {
      if (selectedCode === 'DA' && !this.showDepositAssumptionMessage) {
          this.showDepositAssumptionMessage = true;
          return;
      } else if (selectedCode === 'DC' && !this.showDepositConfirmationMessage) {
          this.showDepositConfirmationMessage = true;
          return;
      }
      return false;
    }

    onClientSelectionChanged(selection: PrismDataSource): void {
        if (this.globalFilterService.selectedEnvironment) {
            this._clientId = this.globalFilterService.selectedEnvironment.ClientId4Digit
        } else {
            return
        }
        this.initializeDepositSettings();
    }

    private initializeDepositSettings(): void {

        this.depositSettingsService.getDepositSettings(this._clientId).then((clientDepositSettings: SettingsDepositModel) => {

            //  If we don't find the deposit type, default it to the first selection (none) in the list.
            if (clientDepositSettings == null || clientDepositSettings.Settings['DepositOption'] === null) {
                this._selectedDepositOption = DepositOptions[0];
                return;
            }
            this._selectedClientModel = clientDepositSettings;
            const index = depositAssumptionCodes.findIndex((code) => clientDepositSettings.Settings['DepositOption'] === code);
            this._selectedDepositOption = DepositOptions[index];
            this.validForm = this._selectedDepositOption !== this._depositOptionSelections[0]
        }, (err) => { this._selectionHasChanged = true; });     //  Re-enable the button if an error occurs.
    }

    ngOnInit(): void {
    }

    public onSelect(selection: SettingsDepositOption): void {
        this.showDepositAssumptionMessage = false;
        this.showDepositConfirmationMessage = false;
        this._selectedDepositOption = selection;
        this._selectionHasChanged = true;
        this.validForm = selection !== this._depositOptionSelections[0]
        this.checkShowMessage(depositAssumptionCodes[selection.ID])
    }

    public onUpdateDepositOption(): void {
        const depositOption: string = depositAssumptionCodes[this.selectedDepositOption.ID];
        const model: SettingsDepositModel = {
            Settings: {},
        };
        model.Settings['DepositOption'] = depositOption;

        const result = this.depositSettingsService.saveDepositSettings(this.globalFilterService.selectedEnvironment.ClientId4Digit, model);
        if (result) {
            this._selectionHasChanged = false;
        }
        if (this.authorizationService.HealthcareTopBar == null || this.authorizationService.HealthcareTopBar.notifyActivity == null) {
            return;
        }
        this.authorizationService.HealthcareTopBar.notifyActivity();
    }
    public hideDepositAssumptionDialog() {
        this.showDepositAssumptionMessage = false;
    }
    public hideDepositConfirmationDialog() {
        this.showDepositConfirmationMessage = false;
    }
}



// WEBPACK FOOTER //
// ./src/app/settings/components/deposit-settings.component.ts